import React from "react";
import Carousel from "./carousel.js";
import ButtonOrang from "./ButtonOrang.js";
import { Link } from "react-router-dom";
import VideoComex from "./VideoComex.js";

export default function BlogDetailContent({ blog }) {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;

  return (
    <section
      data-testid="blog-detail-content"
      className="relative bg-sidom-light dark:bg-sidom-blue pt-40 md:pb-24 pb-16"
    >
      <div className="">
        <div className="container relative ">
          <div className="mb-2 flex justify-start">
            <div className=" ">
              <Link to="/blogs" className="hover:text-sidom-orange font-bold">
                <i className="mdi mdi-arrow-left align-middle"></i> Volver
              </Link>
            </div>
          </div>
          <div className="md:flex text-left ">
            <div className="w-full lg:w-3/5v mb-[60px]">
              <h1 className=" text-3xl sm:text-4xl leading-[1.3] font-medium">
                {blog.titulo}
              </h1>
              <div className="flex mt-5">
                <span className="font-medium">
                  <i className="mdi mdi-calendar-blank-outline me-2"></i>
                  {blog.fecha_publicacion || "Sin fecha"}
                </span>
              </div>
            </div>
          </div>
          <div
            data-testid="img-detail"
            className="flex justify-start items-start text-left"
          >
            <div className="lg:w-full ">
              <div className="relative   ">
                {blog?.imagen && (
                  <img
                    src={`${apiUrl}${
                      blog.imagen?.formats?.large?.url || blog.imagen?.url
                    }`}
                    className="rounded-xl w-[90%] md:w-[60%] max-h-[800px]  mx-auto shadow-md dark:shadow-gray-800 object-contain"
                    alt={blog.titulo}
                    loading="lazy"
                    decoding="async"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-start mt-[30px]">
            <div className=" text-left text-lg">
              {Array.isArray(blog.contenido) &&
                blog.contenido.map((bloque, idx) => {
                  if (
                    bloque.type === "paragraph" &&
                    Array.isArray(bloque.children)
                  ) {
                    return (
                      <p
                        key={idx}
                        className="text-sidom-dark dark:text-sidom-light text-xs sm:text-sm md:text-base lg:text-xl leading-relaxed  mt-4"
                      >
                        {bloque.children.map((child, i) => {
                          if (
                            child.type === "link" &&
                            child.url &&
                            Array.isArray(child.children)
                          ) {
                            return (
                              <a
                                key={i}
                                href={child.url}
                                className="text-sidom-orange underline hover:text-sidom-orange/70"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {child.children.map((subChild, j) => {
                                  if (subChild.bold && subChild.italic) {
                                    return (
                                      <strong key={j}>
                                        <em>{subChild.text}</em>
                                      </strong>
                                    );
                                  } else if (subChild.bold) {
                                    return (
                                      <strong key={j}>{subChild.text}</strong>
                                    );
                                  } else if (subChild.italic) {
                                    return <em key={j}>{subChild.text}</em>;
                                  } else {
                                    return <span key={j}>{subChild.text}</span>;
                                  }
                                })}
                              </a>
                            );
                          }

                          if (child.bold && child.italic) {
                            return (
                              <strong key={i}>
                                <em>{child.text}</em>
                              </strong>
                            );
                          } else if (child.bold) {
                            return <strong key={i}>{child.text}</strong>;
                          } else if (child.italic) {
                            return <em key={i}>{child.text}</em>;
                          } else {
                            return <span key={i}>{child.text}</span>;
                          }
                        })}
                      </p>
                    );
                  }
                  return null;
                })}
            </div>
          </div>
          <div data-testid="carousel-detail" className="mt-[100px] mb-[100px]">
            {Array.isArray(blog.img) && blog.img.length > 0 && (
              <Carousel images={blog.img} />
            )}
          </div>
        </div>

        {blog?.video && (
          <div className="container  mt-[100px] mb-[100px] ">
            <VideoComex
              key={blog.video[0]?.id}
              video={blog.video[0]?.url}
              controls={true}
              autoPlay={true}
              muted={true}
              loop={true}
            />
          </div>
        )}

        {blog.boton && (
          <div className="flex justify-center items-center container">
            <ButtonOrang
              text={blog.boton}
              link={blog.url?.startsWith("http") ? blog.url : `//${blog.url}`}
              target="_blank"
            />
          </div>
        )}
      </div>
    </section>
  );
}
